import { useEffect, useRef, useState } from 'react';

const VERSION_CHECK_INTERVAL = 5 * 60 * 1000; // 5 分鐘
const META_URL = '/static/meta.json';

const fetchBuildTime = async (): Promise<string | null> => {
    try {
        const res = await fetch(`${META_URL}?x=${Date.now()}`, { cache: 'no-store' });
        const data = await res.json();
        return data.buildTime ?? null;
    } catch {
        return null;
    }
};

const useVersionCheck = () => {
    const [hasNewVersion, setHasNewVersion] = useState(false);
    const initialBuildTime = useRef<string | null>(null);

    useEffect(() => {
        fetchBuildTime().then(buildTime => {
            initialBuildTime.current = buildTime;
        });

        const timer = setInterval(async () => {
            if (hasNewVersion) return;
            const buildTime = await fetchBuildTime();
            if (
                buildTime !== null &&
                initialBuildTime.current !== null &&
                buildTime !== initialBuildTime.current
            ) {
                setHasNewVersion(true);
            }
        }, VERSION_CHECK_INTERVAL);

        return () => clearInterval(timer);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return { hasNewVersion };
};

export default useVersionCheck;
